function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 11.8457C5.09375 11.8457 5.24609 11.8105 5.39258 11.7285C8.72656 9.85938 9.86914 9.06836 9.86914 6.92969V2.44727C9.86914 1.83203 9.60547 1.63867 9.10742 1.42773C8.41602 1.14062 6.18359 0.337891 5.49219 0.0976562C5.33398 0.0449219 5.16406 0.00976562 5 0.00976562C4.83594 0.00976562 4.66602 0.0566406 4.51367 0.0976562C3.82227 0.296875 1.58398 1.14648 0.892578 1.42773C0.400391 1.63281 0.130859 1.83203 0.130859 2.44727V6.92969C0.130859 9.06836 1.2793 9.85352 4.60742 11.7285C4.75977 11.8105 4.90625 11.8457 5 11.8457ZM5.23438 1.00586C6.11914 1.35742 7.83594 1.97852 8.74414 2.28906C8.90234 2.34766 8.9375 2.42969 8.9375 2.62891V6.71289C8.9375 8.52344 8.07031 8.99805 5.36328 10.6445C5.26367 10.709 5.1875 10.7441 5.12305 10.7617V0.970703C5.1582 0.976562 5.19336 0.988281 5.23438 1.00586Z",
  fill: "#5AE3FF"
});

function SvgIconShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShield);
export default __webpack_public_path__ + "static/media/icon-shield.82f3e8dd.svg";
export { ForwardRef as ReactComponent };